<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="title-h3">
          {{selectDeviceAccountTitle}}
      </div>
      <div class="vertical-center-box">
        <el-date-picker class="mr-r4" style="width: 250px" v-model="dateRange" :clearable="false" :editable="false" type="daterange" @change="changeDate" align="right" unlink-panels :range-separator="defaultDateRangeOptions.rangeSeparator"
          :start-placeholder="defaultDateRangeOptions.startPlaceholder" :end-placeholder="defaultDateRangeOptions.endPlaceholder" :picker-options="defaultDateRangeOptions.pickerOptions"
          :default-time="defaultDateRangeOptions.defaultTime"></el-date-picker>
        <el-button class="mr-r4" size="mini" @click="onClickExcelExport">
          <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
          <span style="left:2px;bottom:5px;">  엑셀출력</span>
        </el-button>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="loading" ref="histTable" slot="body" :data="tableData" :columns="tableColumn" remote @condition-change="loadData"
    :column-default="columnDefault" :pagination="false" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;">
      <template slot-scope="scope" slot="sync-type">
        <span v-if="scope.row.status === 'Y'" class="state-normal">성공</span>
        <span v-else class="state-abnormal">실패</span>
      </template>
    </el-table-wrapper>
  </div>
</template>

<script>
import { isNil, isEmpty } from 'lodash';
import moment from 'moment';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import { getDateToString, defaultDateRangeOptions } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import NetdeviceAccountSettingsAPI from '@/api/settings/netdevice/netdevice-account-settings';

export default {
  name: 'WPwdChangeHistList',
  components: {
  },
  props: {
    selectPhysicalNode: Object,
    NetdeviceAccountSettingsAPI,
  },
  data() {
    const startDatetime = moment()
      .subtract(1, 'month')
      .startOf('day')
      .toDate();
    const endDatetime = moment()
      .endOf('day')
      .toDate();
    return {
      loading: false,
      defaultDateRangeOptions,
      params: {
        objId: '',
        objCompanyId: '',
        startDatetime: Date,
        endDatetime: Date,
      },
      dateRange: [startDatetime, endDatetime],
      showSearchTool: false,
      tableData: [],
      columnDefault,
      tableColumn: [
        {
          prop: 'status',
          remoteProp: 'hd.chng_status',
          label: '구분',
          scopedSlot: 'sync-type',
          width: 70,
          filters: [
            {
              text: '성공',
              value: 'Y',
            },
            {
              text: '실패',
              value: 'N',
            },
          ],
        },
        {
          prop: 'objName',
          remoteProp: 'o.obj_name',
          label: '장비명',
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP주소',
          width: 160,
          searchable: true,
        },
        {
          prop: 'userId',
          remoteProp: 'hd.user_id',
          label: '계정ID',
          formatter: this.getEmptyText,
          width: 160,
          searchable: true,
        },
        {
          prop: 'changeDatetime',
          label: '동기화일시',
          formatter: this.getDateFormatter,
          width: 160,
        },
      ],
    };
  },
  computed: {
    selectDeviceAccountTitle() {
      return !isNil(this.selectPhysicalNode) && !isNil(this.selectPhysicalNode.label) && this.selectPhysicalNode.label !== '' ? `[${this.selectPhysicalNode.label}] 패스워드 변경이력` : '패스워드 변경이력';
    },
  },
  watch: {
    selectPhysicalNode: {
      handler() {
        if (this.$refs.histTable) {
          this.$refs.histTable.clearFilter();
          this.loadData();
        } else {
          this.$nextTick(() => {
            this.$refs.histTable.clearFilter();
            this.loadData();
          });
        }
      },
      immediate: false,
    },
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.histTable.getParameter();
      this.params = {
        objId: null,
        objCompanyId: null,
        startDatetime: this.dateRange[0].getTime(),
        endDatetime: this.dateRange[1].getTime(),
        ...tableParams,
      };
      if (!isNil(this.selectPhysicalNode) && this.selectPhysicalNode.type !== 'root') {
        if (this.selectPhysicalNode.obj) {
          this.params.objId = this.selectPhysicalNode.obj.objId;
        } else {
          this.params.objCompanyId = this.selectPhysicalNode.objCompanyId;
        }
      }
      this.loading = true;
      NetdeviceAccountSettingsAPI.getDeviceAccountPwdHistList(this.params).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '패스워드 변경이력', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '패스워드 변경이력', false));
      }).finally(() => {
        this.loading = false;
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    onClickExcelExport() {
      NetdeviceAccountSettingsAPI.exportDeviceAccountPwdHistList(this.params);
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    changeDate() {
      this.loadData();
    },
    getEmptyText(row, column, value) {
      if (!isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/DeviceAccountSettings/PwdChangeHist/component/PwdChangeHistList.vue